document.addEventListener("DOMContentLoaded", function() {

	loadFilterOptionRow();
	initHomeTabbedSearch();
	document.querySelectorAll('form[action="/search"]').forEach(searchForm => {
		budgetNameValue({ form: searchForm });
	});

	// Auto-redirect logic for search form submission
		document.querySelectorAll('form[action="/search"]').forEach(searchForm => {
			searchForm.addEventListener('submit', async function (e) {
            e.preventDefault();

            if (typeof jsLoadResults !== 'undefined' && jsLoadResults === true) {
            	loadSearchResults();
            	if (!userScrolling) {
					document.getElementById('results-container')?.scrollIntoView({ 
						behavior: 'smooth', 
						block: 'start' 
					});
				}
				document.getElementById('filter_popup')?.classList.add('hidden');
			    if (document.getElementById('filter_popup')) {
			    	document.getElementById('filter_popup').style.overflow = '';
			    }
			    document.documentElement.style.overflow = 'initial'; 
            	return;
            }
            // Build the query string
            const params = new URLSearchParams(new FormData(searchForm));
            params.append('faceted_api', 'true');

	        const skipKeys = ['toggle', 'manufacturer_redirect', 'search-type', 'type', 'faceted_api'];

	        const meaningfulParams = [...params.entries()].filter(([key, value]) => 
	            !skipKeys.includes(key) && value.trim() !== ''
	        );

	        if (meaningfulParams.length === 0) {
	            // console.log('Search aborted — only default params present.');
	            searchForm.submit();
	        }

            try {
                const response = await fetch(`/search?${params.toString()}`, {
                    method: 'GET',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });

                const data = await response.json();
                
                if (data.success && data.url) {
                    // Faceted URL found
                    window.location.href = data.url;
                } else {
                    // No faceted URL
                    window.location.href = `/search?${params.toString().replace('&faceted_api=true', '')}`;
                }
            } catch (error) {
                console.error('Faceted URL check failed:', error);
                // Fallback
                searchForm.submit();
            }
	        });
	    });

	/*const mileageOptions = Object.values(mileageValues).map(value => ({
      value,
      label: `${Number(value).toLocaleString()} Miles`,
      selected: defaultSelections.mileage === String(value)
    }));

    const maintenanceOptions = [
      { value: 'yes', label: 'Yes', selected: defaultSelections.maintenance === 'yes' },
      { value: 'no', label: 'No', selected: defaultSelections.maintenance === 'no' }
    ];*/

});

function initHomeTabbedSearch() {
	const filterForm = document.getElementById('filter_popup');
	const tabs = document.querySelectorAll('[data-home-search-tabs] .tab-btn');

	if (!filterForm || tabs.length === 0) return;

	const searchTypeInputs = Array.from(filterForm.querySelectorAll('input[name="search-type"]'));
	const tabToSearchType = {
		cars: 'car',
		vans: 'van'
	};

	const setActiveDropdown = (selected) => {
		const selectedKey = String(selected || '').toLowerCase();
		const alternateKey = selectedKey.endsWith('s') ? selectedKey.slice(0, -1) : selectedKey + 's';

		filterForm.querySelectorAll('[data-search-dropdown]').forEach(dropdown => {
			const dropdownKey = String(dropdown.dataset.searchDropdown || '').toLowerCase();
			const isActive = dropdownKey === selectedKey || dropdownKey === alternateKey;
			dropdown.classList.toggle('hidden', !isActive);
			dropdown.querySelectorAll('input, select, textarea, button').forEach(field => {
				if (isActive) {
					if (field.dataset.prevDisabled !== undefined) {
						field.disabled = field.dataset.prevDisabled === '1';
						delete field.dataset.prevDisabled;
					}
				} else {
					field.dataset.prevDisabled = field.disabled ? '1' : '0';
					field.disabled = true;
				}
			});
		});
	};

	const normaliseTab = (value) => (String(value || '').toLowerCase().startsWith('van') ? 'vans' : 'cars');

	const setActiveTab = (selected) => {
		const activeTab = normaliseTab(selected);

		tabs.forEach(button => {
			const isActive = button.dataset.tab === activeTab;
			button.classList.toggle('border-blue-600', isActive);
			button.classList.toggle('text-black', isActive);
			button.classList.toggle('border-transparent', !isActive);
			button.classList.toggle('text-neutral-500', !isActive);
		});

		if (searchTypeInputs.length && tabToSearchType[activeTab]) {
			searchTypeInputs.forEach(input => {
				input.value = tabToSearchType[activeTab];
			});
		}

		setActiveDropdown(activeTab);
	};

	const getInitialTab = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlType = urlParams.get('search-type');
		const inputType = searchTypeInputs.length ? searchTypeInputs[0].value : '';
		return normaliseTab(urlType || inputType);
	};

	tabs.forEach(button => {
		button.addEventListener('click', function () {
			setActiveTab(this.dataset.tab);
		});
	});

	setActiveTab(getInitialTab());
}

	var selectedOptionsForFilterRow = [], availableManufacturers = null, availableModels = null;
	const manufacturersApiCache = new Map();

	function fetchManufacturersCached(url) {
		if (manufacturersApiCache.has(url)) {
			return manufacturersApiCache.get(url);
		}

		const request = fetch(url)
			.then(res => res.ok ? res.json() : Promise.reject('Failed to fetch manufacturers'))
			.catch(err => {
				manufacturersApiCache.delete(url);
				throw err;
			});

		manufacturersApiCache.set(url, request);
		return request;
	}

	function fadeOutIfEmpty(containerId) {
		const container = document.getElementById(containerId);
		const ul = container?.querySelector('ul');

		if (!container || !ul) return;

		// Use timeout to allow DOM rendering to complete
		setTimeout(() => {
			if (ul.children.length === 0) {
				container.style.opacity = '0.5';
				container.style.transition = 'opacity 0.3s ease';
			} else {
				container.style.opacity = '1';
			}
		}, 100);
	}

	function vehicleCount(p = []) {
		const counters = document.querySelectorAll('.counter');
		if (counters.length === 0) return;

		// console.log(p);

		fetch('/api/vehicle-count?' + p)
			.then(res => res.json())
			.then(data => {
				document.querySelectorAll('.counter').forEach(el => {
					const currentNum = parseInt(el.textContent);
					const countUp = new CountUp(el, currentNum, data.count);
					if (!countUp.error) {
						countUp.start();
					} else {
						console.error(countUp.error);
					}
				});
				// console.log('Vehicle count:', data.count);
			})
			.catch(err => {
				console.error('Error fetching vehicle count:', err);
			});
	}

	function updateDisplay(container, label = 'Select') {
		const listbox = container.querySelector('[role="listbox"]');
		if (!listbox) return;

		listbox.querySelectorAll('input[type="hidden"]').forEach(input => {
			const tick = input.closest('li')?.querySelector('.tick');
			const listItem = input.closest('li');

			if (input && !input.disabled) {
				if (listItem) listItem.classList.add('font-semibold');
				if (tick) tick.src = '/themes/driveelectric/img/icons/dropdowntick.svg';
			} else {
				if (listItem) listItem.classList.remove('font-semibold');
				if (tick) tick.src = '/themes/driveelectric/img/icons/dropdowntickempty.svg';
			}
		});

		showSelectedValues(container);
	}

	function getFormFromContext(container = null, formId = null) {
		if (formId) {
			return document.getElementById(formId);
		}

		return container?.closest('form') || null;
	}

	function getDropdownContext({ containerId = null, container = null, formId = null } = {}) {
		const resolvedContainer = container || (containerId ? document.getElementById(containerId) : null);
		const form = getFormFromContext(resolvedContainer, formId);

		return {
			container: resolvedContainer,
			form,
			formId: formId || form?.id || null
		};
	}

	function queryWithinContext(context, selector, fallbackToDocument = false) {
		const match = context.form?.querySelector(selector) || context.container?.querySelector(selector) || null;
		if (match || !fallbackToDocument) return match;

		return document.querySelector(selector);
	}

	function queryAllWithinContext(context, selector, fallbackToDocument = false) {
		const root = context.form || context.container;
		if (root) {
			return [...root.querySelectorAll(selector)];
		}

		return fallbackToDocument ? [...document.querySelectorAll(selector)] : [];
	}

	function getInputNameVariants(name) {
		return [name, `${name}[]`];
	}

	function getEnabledInputsForName(name, excludeInput = null) {
		const selectors = getInputNameVariants(name)
			.map(inputName => `input[name="${inputName}"]:not([disabled])`)
			.join(', ');

		return [...document.querySelectorAll(selectors)].filter(input => input !== excludeInput);
	}

	function syncGlobalSelectionsForContainer(container) {
		if (!container) return;

		const names = new Set(
			[...container.querySelectorAll('input[type="hidden"]')]
				.map(input => input.name.replace(/\[\]$/, ''))
				.filter(Boolean)
		);

		names.forEach(name => {
			selectedOptionsForFilterRow = selectedOptionsForFilterRow.filter(item => item.name !== name);

			const seenValues = new Set();
			getEnabledInputsForName(name).forEach(input => {
				const value = String(input.value);
				if (seenValues.has(value)) return;
				seenValues.add(value);
				selectedOptionsForFilterRow.push({
					name,
					value: input.value,
					label: input.dataset.name || input.value
				});
			});
		});

		loadFilterOptionRow();
	}

	function resetLinkedModelDropdown(containerId, label = 'Model') {
		const modelBox = document.getElementById(containerId);
		if (!modelBox) return;

		clearBtn(modelBox, label);

		const modelListbox = modelBox.querySelector('.multiselect-list');
		if (modelListbox) {
			modelListbox.innerHTML = '';
		}

		updateDisplay(modelBox, label);
		fadeOutIfEmpty(containerId);
	}


	function clearBtn(container, label = 'Select', inputName = null) {
		const clear_btn = container.querySelector('.clear_btn');
		if (!clear_btn) return;
		const context = getDropdownContext({ container });

		// clear_btn.addEventListener('click', e => {
		// 	e.stopPropagation();

			if (!inputName) {
				const firstInput = container.querySelector('input[type="hidden"]');
				inputName = firstInput?.name || '';
			}

			const selector = `input[name="${inputName}"], input[name="${inputName}[]"]`;
			const inputs = container.querySelectorAll(selector);
			const listItems = container.querySelectorAll('li');

			inputs.forEach(input => {
				input.disabled = true;
			});

			listItems.forEach(li => {
				const tick = li.querySelector('.tick');
				if (tick) {
					tick.src = '/themes/driveelectric/img/icons/dropdowntickempty.svg';
					li.classList.remove('font-semibold');
				}
			});

			syncGlobalSelectionsForContainer(container);
			updateDisplay(container, label);

			if (context.form && context.form.querySelector('.counter')) {
				const formParams = new URLSearchParams(new FormData(context.form)).toString();
				vehicleCount(formParams);
			}

			if (typeof jsLoadResults !== 'undefined' && jsLoadResults === true) {
				loadSearchResults();
			}
		// });
	}

	function getSelectedFromURL(name) {
		const params = new URLSearchParams(window.location.search);
		return params.getAll(name);
	}

	function closeDropDown(container, listboxdiv) {
		if (!listboxdiv.classList.contains('hidden')) {
			listboxdiv.classList.add('hidden');
		}
		if (container.classList.contains('open')) {
			container.classList.remove('open');
		}
	}


	function loadManufacturersMultiselect(searchType = 'car', config = {}) {
	    const containerId = config.containerId || 'manufacturer-multiselect';
	    const modelContainerId = config.modelContainerId ?? 'model-select';
	    const formId = config.formId || null;
	    const name = config.name || 'make';
	    const modelName = config.modelName || 'model';
	    const multiselect = config.multiselect ?? true;
	    const useUrlSelection = config.useUrlSelection !== false;
	    const searchTypeSelector = config.searchTypeSelector || '#search-type';
	    const fuelTypeSelector = config.fuelTypeSelector || 'input[name="fuel_type"]';
	    const context = getDropdownContext({ containerId, formId });

	    if (!context.container) return;

	    const searchTypeValue = queryWithinContext(context, searchTypeSelector, true)?.value || searchType;
	    const fuelType = queryWithinContext(context, fuelTypeSelector, true)?.value || null;

	    let apiUrl;

	    if (searchTypeValue === 'used-evs') {
	        apiUrl = '/api/used-evs/manufacturers';
	    } else if (fuelType === 'Electric') {
	        apiUrl = `/api/${searchTypeValue}/manufacturers/ev/available-count`;
	    } else if (typeof offerStock !== 'undefined' && offerStock === 'offer-stock') {
	        apiUrl = `/api/${searchTypeValue}manufacturers/ev/available-count?offers=stock`;
	    } else {
	        apiUrl = `/api/${searchTypeValue}manufacturers/ev/available-count`;
	    }

	    fetchManufacturersCached(apiUrl)
	        .then(data => {
	            const manufacturers = Array.isArray(data)
	                ? data
	                : (Array.isArray(data?.data) ? data.data : []);

	            const options = manufacturers
	                .filter(item => item.derivative_count > 0)
	                .sort((a, b) => a.name.localeCompare(b.name))
	                .map(item => ({
	                    value: item.id.toString(),
	                    key: item.id.toString(),
	                    label: `${item.name.toUpperCase()} (${item.derivative_count})`
	                }));

	            generateDropdown({
	                containerId,
	                options,
	                multiselect,
	                name,
	                modelContainerId,
	                modelName,
	                useUrlSelection,
	                formId: context.formId,
	                preselectedValues: config.preselectedValues || (
	                    typeof preSelectMake !== 'undefined' ? preSelectMake : []
	                )
	            });

	            const selectedMakes = [...(context.container?.querySelectorAll(`input[name="${name}${multiselect ? '[]' : ''}"]:not([disabled])`) || [])]
	                .map(i => i.value);

	            if (selectedMakes.length > 0 && modelContainerId) {
	                loadModelsSelect(searchTypeValue, selectedMakes, false, {
	                    containerId: modelContainerId,
	                    formId: context.formId,
	                    name: modelName,
	                    useUrlSelection,
	                    preselectedValues: config.preselectedModels || (
	                        typeof preSelectModel !== 'undefined' ? preSelectModel : []
	                    )
	                });

	                if (typeof jsLoadResults !== 'undefined' && jsLoadResults === true) {
	                    loadSearchResults();
	                }
	            }

	            window.availableManufacturers = manufacturers;
	        })
	        .catch(err => {
	            console.error(err);

	            const listbox = context.container?.querySelector('.multiselect-list');

	            if (listbox) {
	                listbox.innerHTML = `<li class="text-red-500 px-3 py-2">Failed to load manufacturers.</li>`;
	            }
	        });
	}

	function loadModelsSelect(type, manufacturers = [], ev_only = false, config = {}) {
	    const containerId = config.containerId || 'model-select';
	    const formId = config.formId || null;
	    const name = config.name || 'model';
	    const multiselect = config.multiselect ?? true;
	    const useUrlSelection = config.useUrlSelection !== false;
	    const context = getDropdownContext({ containerId, formId });

	    if (!context.container) return;

	    const buildUrl = (manufacturer) => {
	        const baseUrl =
	            type === 'used_ev' || type === 'used-evs'
	                ? `/api/used-evs/models/${manufacturer}`
	                : `/api/${type}/models/${manufacturer}/ev`;

	        const params = new URLSearchParams({ get_page: '1' });
	        if (type !== 'used_ev' && type !== 'used-evs') {
	            params.set('available', '1');
	        }

	        return `${baseUrl}?${params.toString()}`;
	    };

	    const normalise = (r) => {
	        const rows = [];
	        if (!r) return rows;

	        if (Array.isArray(r)) {
	            for (const item of r) {
	                if (item && item.id != null && item.name) {
	                    rows.push({
	                        value: item.id,
	                        key: String(item.slug || item.key || item.id),
	                        label: String(item.name).toUpperCase(),
	                        page: item.page || false,
	                    });
	                }
	            }
	        } else if (typeof r === 'object') {
	            for (const [k, v] of Object.entries(r)) {
	                if (v && typeof v === 'object') {
	                    if (v.id != null && v.name) {
	                        rows.push({
	                            value: v.id,
	                            key: String(k),
	                            label: String(v.name).toUpperCase(),
	                            page: v.page || false,
	                        });
	                    }
	                } else if (typeof v === 'string') {
	                    rows.push({
	                        value: Number.isNaN(Number(k)) ? k : Number(k),
	                        key: String(k),
	                        label: v.toUpperCase(),
	                        page: false,
	                    });
	                }
	            }
	        }

	        return rows;
	    };

	    const fetchPromises = manufacturers.map((m) =>
	        fetch(buildUrl(m))
	            .then((res) => {
	                if (!res.ok) throw new Error(`Failed for manufacturer ${m}`);
	                return res.json();
	            })
	            .catch((err) => {
	                console.error('Fetch error:', err);
	                return null;
	            })
	    );

	    Promise.all(fetchPromises)
	        .then((results) => {
	            const records = results.flatMap((r) => normalise(r));

	            records.sort((a, b) => (a.label || '').localeCompare(b.label || ''));

	            generateDropdown({
	                containerId,
	                options: records,
	                multiselect,
	                name,
	                useUrlSelection,
	                formId: context.formId,
	                preselectedValues: config.preselectedValues || (
	                    typeof preSelectModel !== 'undefined' ? preSelectModel : []
	                )
	            });

	            window.availableModels = window.availableModels || {};
	            window.availableModels[containerId] = Object.fromEntries(
	                records.map((r) => [r.key, { id: r.value, name: r.label, page: r.page }])
	            );

	            fadeOutIfEmpty(containerId);

	            if (!records.length) {
	                const listbox = context.container?.querySelector('.multiselect-list');

	                if (listbox) {
	                    listbox.innerHTML = `<li class="px-3 py-2 text-gray-500">No models available for the selected manufacturer(s).</li>`;
	                }
	            }
	        })
	        .catch((err) => {
	            console.error('Model loading failed:', err);

	            const listbox = context.container?.querySelector('.multiselect-list');

	            if (listbox) {
	                listbox.innerHTML = `<li class="text-red-500 px-3 py-2">Failed to load models.</li>`;
	            }
	        });
	}

	const requestedSearchType = (() => {
		const value = new URLSearchParams(window.location.search).get('search-type') || '';
		return String(value).toLowerCase().startsWith('van') ? 'van' : 'car';
	})();

	const manufacturerMultiselect = document.getElementById('manufacturer-multiselect');
	if (manufacturerMultiselect) {
		const manufacturerFormId = getFormFromContext(manufacturerMultiselect)?.id || 'filter_popup';
	    loadManufacturersMultiselect('car', {
	        containerId: 'manufacturer-multiselect',
	        modelContainerId: 'model-select',
	        formId: manufacturerFormId,
	        name: 'make',
	        modelName: 'model',
	        useUrlSelection: requestedSearchType === 'car',
	        searchTypeSelector: manufacturerFormId === 'filter_popup' ? '[data-search-type-source="car"]' : '#search-type'
	    });
	}

	if (document.getElementById('homepage-manufacturer-multiselect')) {
	    loadManufacturersMultiselect('car', {
	        containerId: 'homepage-manufacturer-multiselect',
	        modelContainerId: 'homepage-model-select',
	        formId: 'homepage-search-form',
	        name: 'make',
	        modelName: 'model'
	    });
	}

	if (document.getElementById('search-aside-manufacturer-multiselect')) {
		const searchAsideForm = document.getElementById('search-aside-form');
		const searchAsideTypeValue = String(searchAsideForm?.querySelector('input[name="search-type"]')?.value || 'car').toLowerCase();
		const searchAsideType = searchAsideTypeValue.startsWith('van') ? 'van' : 'car';
	    loadManufacturersMultiselect(searchAsideType, {
	        containerId: 'search-aside-manufacturer-multiselect',
	        modelContainerId: 'search-aside-model-select',
	        formId: 'search-aside-form',
	        name: 'make',
	        modelName: searchAsideType === 'van' ? 'van_model' : 'model',
	        searchTypeSelector: 'input[name="search-type"]'
	    });
	}

	const vanManufacturerMultiselect = document.getElementById('van-manufacturer-multiselect');
	if (vanManufacturerMultiselect) {
		const vanFormId = getFormFromContext(vanManufacturerMultiselect)?.id || 'van-search-form';
	    loadManufacturersMultiselect('van', {
	        containerId: 'van-manufacturer-multiselect',
	        modelContainerId: 'van-model-select',
	        formId: vanFormId,
	        name: 'make',
	        modelName: 'van_model',
	        useUrlSelection: requestedSearchType === 'van',
	        searchTypeSelector: vanFormId === 'filter_popup' ? '[data-search-type-source="van"]' : '#search-type'
	    });
	}

	if (document.getElementById('homepage-manufacturer-multiselect-van')) {
	    loadManufacturersMultiselect('van', {
	        containerId: 'homepage-manufacturer-multiselect-van',
	        modelContainerId: null,
	        formId: 'nav-van-form',
	        name: 'make',
	        modelName: 'van_model'
	    });
	}

function showSelectedValues(container) {

	if (!container) return;
	const selectedValuesEl = container.querySelector('.selected-values');
	if (!selectedValuesEl) return;
	selectedValuesEl.classList.add('truncate', 'overflow-hidden', 'max-w-0', 'flex-1');
	const selectedLabels = [...container.querySelectorAll('input[type="hidden"]:not([disabled])')]
		.map(input => input.dataset.name)
		.filter(Boolean);
	if (selectedLabels.length > 0) {
		selectedValuesEl.textContent = selectedLabels.join(', ');
		selectedValuesEl.title = selectedValuesEl.textContent;
		selectedValuesEl.classList.remove('hidden');
	} else {
		selectedValuesEl.textContent = '';
		selectedValuesEl.removeAttribute('title');
		selectedValuesEl.classList.add('hidden');
	}

}

	function bodyTypeDropdown() {
		/*const bodyTypes = [
			{ value: 'hatchback', 	key: 'hatchback', 	label: 'Hatchback' },
			{ value: 'suv', 		key: 'suv', 		label: 'SUV' },
			{ value: 'saloon', 		key: 'saloon', 		label: 'Saloon' },
			{ value: 'estate', 		key: 'estate', 		label: 'Estate' },
		]; */
		
		generateDropdown({
			containerId: 'bodyType-select',
			options: carSizeOptions,
			multiselect: true,
			name: 'body_type',
			preselectedValues: (typeof bodyTypeDropdownPreselected !== 'undefined') 
	            ? bodyTypeDropdownPreselected 
	            : []
		});
	}

	bodyTypeDropdown();

	function vanBodyTypeDropdown() {
		if (typeof vanSizeOptions !== 'undefined') {
			generateDropdown({
				containerId: 'bodyType-van-select',
				options: vanSizeOptions,
				multiselect: true,
				name: 'body_type',
				preselectedValues: (typeof vanBodyTypeDropdownPreselected !== 'undefined') 
	            ? vanBodyTypeDropdownPreselected 
	            : []
			});
		}
	}

	vanBodyTypeDropdown();


	function newUsedDropdown() {
	    const options = [
	        { value: '0', key: 'new', label: 'New' },
	        { value: '1', key: 'used', label: 'Used' }
	    ];

	    generateDropdown({
	        containerId: 'newUsed-select',
	        options,
	        multiselect: false,
	        name: 'used_price',
	        preselectedValues: (typeof newUsedDropdownPreselected !== 'undefined') 
	            ? newUsedDropdownPreselected 
	            : []
	    });
	}
	newUsedDropdown();

	function contractTypeDropdown() {
		const options = [
			{ value: 'business', key: 'business', label: 'Business' },
			{ value: 'personal', key: 'personal', label: 'Personal' }
		];
		generateDropdown({ containerId: 'contract-type-select', options, multiselect: false, name: 'type', preselectedValues: ['personal'] });
	} contractTypeDropdown();

	function transmissionDropdown() {
		const options = [
			{ value: 'A', key: 'A', label: 'Automatic' },
			{ value: 'M', key: 'M', label: 'Manual' }
		];
		
		generateDropdown({ containerId: 'transmission-select', options, multiselect: false, name: 'transmission', preselectedValues: (typeof transmissionDropdownPreselected !== 'undefined') 
	            ? transmissionDropdownPreselected 
	            : [] });
	} transmissionDropdown()

	function fueltypeDropdown() {
		const options = [
			{ value: '',  key: '', label: 'Any' },
			{ value: 'electric', key: 'Electric', label: 'Electric' },
			{ value: 'hybrid', key: 'Hybrid', label: 'Hybrid' },
			{ value: 'petrol', key: 'Petrol', label: 'Petrol' },
			{ value: 'diesel', key: 'Diesel', label: 'Diesel' }
		];
		['fueltype-select', 'fueltype-select-van'].forEach(containerId => {
			if (!document.getElementById(containerId)) return;

			generateDropdown({
				containerId,
				options,
				multiselect: true,
				name: 'fuel_type',
				formId: getFormFromContext(document.getElementById(containerId))?.id || null,
				preselectedValues: (typeof fueltypeDropdownPreselected !== 'undefined')
					? fueltypeDropdownPreselected
					: []
			});
		});
	}  fueltypeDropdown();

	function mpgRangeDropdown() {
		const options = [
			{ value: '0-100',   	key: '0-100',   label: 'Up to 100 miles' },
			{ value: '100-150', 	key: '100-150', label: '100 - 150 miles' },
			{ value: '150-200', 	key: '150-200', label: '150 - 200 miles' },
			{ value: '200-250', 	key: '200-250', label: '200 - 250 miles' },
			{ value: '250-300', 	key: '250-300', label: '250 - 300 miles' },
			{ value: '300-1000',    key: '300-1000',    label: '300+ miles' }];

		['mpgRange-select', 'mpgRange-select-nav', 'search-aside-mpg-range-select'].forEach(containerId => {
			if (!document.getElementById(containerId)) return;

			generateDropdown({
				containerId,
				options,
				multiselect: false,
				name: 'electric_range',
				formId: getFormFromContext(document.getElementById(containerId))?.id || null
			});
		});
	} mpgRangeDropdown();
	function mileageDropdown() {
		const options = [
			{ value: '5000', key: '5000', label: '5,000 Miles' },
			{ value: '8000', key: '8000', label: '8,000 Miles' },
			{ value: '10000', key: '10000', label: '10,000 Miles' },
			{ value: '12000', key: '12000', label: '12,000 Miles' },
			{ value: '15000', key: '15000', label: '15,000 Miles' }
		];
		generateDropdown({ containerId: 'mileage-select', options, multiselect: false, name: 'mileage' });
	} mileageDropdown();
	
	function intialPaymentDropdown() {
		const options = [
			{ value: '1', key: '1', label: '1 Month' },
			{ value: '3', key: '3', label: '3 Months' },
			{ value: '6', key: '6', label: '6 Months' },
			{ value: '9', key: '9', label: '9 Months' },
			{ value: '12', key: '12', label: '12 Months' }
		];
		generateDropdown({ containerId: 'intialPayment-select', options, multiselect: false, name: 'initial_profile', preselectedValues: (typeof intialPaymentDropdownPreselected !== 'undefined') ? intialPaymentDropdownPreselected : [] });
	} intialPaymentDropdown();

	var budgetOptionsArray = Array.from({ length: 41 }, function (_, index) {
		var value = 200 + (index * 50);
		return { value: String(value), key: String(value), label: `£${value} max per month` };
	});

	function budgetFromDropdown() {
		const options = budgetOptionsArray;
		['budget-from', 'budget-from-nav', 'budget-from-van', 'search-aside-budget-from'].forEach(containerId => {
			if (!document.getElementById(containerId)) return;

			generateDropdown({
				containerId,
				options,
				multiselect: false,
				name: 'budget-from',
				formId: getFormFromContext(document.getElementById(containerId))?.id || null,
				preselectedValues: (typeof budgetFromDropdownPreselected !== 'undefined') ? budgetFromDropdownPreselected : []
			});
		});
	} budgetFromDropdown();

	function budgetToDropdown() {
		const options = budgetOptionsArray;
		['budget-to', 'budget-to-nav'].forEach(containerId => {
			if (!document.getElementById(containerId)) return;

			generateDropdown({
				containerId,
				options,
				multiselect: false,
				name: 'budget-to',
				formId: getFormFromContext(document.getElementById(containerId))?.id || null,
				preselectedValues: (typeof budgetToDropdownPreselected !== 'undefined') ? budgetToDropdownPreselected : []
			});
		});
	} budgetToDropdown();

	function payloadSelectDropdown() {
		const options = [
			  { value: '0-500', key: '0-500', label: '0–500 kg' },
			  { value: '501-750', key: '501-750', label: '501–750 kg' },
			  { value: '751-1000', key: '751-1000', label: '751–1000 kg' },
			  { value: '1001-1250', key: '1001-1250', label: '1001–1250 kg' },
			  { value: '1251-1500', key: '1251-1500', label: '1251–1500 kg' },
			  { value: '1501-1750', key: '1501-1750', label: '1501–1750 kg' },
			  { value: '1751-2000', key: '1751-2000', label: '1751–2000 kg' },
			  { value: '2001-2250', key: '2001-2250', label: '2001–2250 kg' },
			  { value: '2251-2500', key: '2251-2500', label: '2251–2500 kg' },
			  { value: '2501-10000', key: '2501-10000', label: '2501+ kg' }
			];
		generateDropdown({ containerId: 'payload-select', options, multiselect: false, name: 'payload' });
	} payloadSelectDropdown();

	function loadLengthSelectDropdown() {
		const options = [
		  { value: '0-464', key: '0-464', label: '0–464 mm' },
		  { value: '465-504', key: '465-504', label: '465–504 mm' },
		  { value: '505-528', key: '505-528', label: '505–528 mm' },
		  { value: '529-650', key: '529-650', label: '529–650 mm' },
		  { value: '651-734', key: '651-734', label: '651–734 mm' },
		  { value: '735-953', key: '735-953', label: '735–953 mm' },
		  { value: '954-1134', key: '954-1134', label: '954–1134 mm' },
		  { value: '1135-1328', key: '1135-1328', label: '1135–1328 mm' },
		  { value: '1329-1500', key: '1329-1500', label: '1329–1500 mm' },
		  { value: '1501-1650', key: '1501-1650', label: '1501–1650 mm' },
		  { value: '1651-1800', key: '1651-1800', label: '1651–1800 mm' },
		  { value: '1801-2000', key: '1801-2000', label: '1801–2000 mm' },
		  { value: '2001-2250', key: '2001-2250', label: '2001–2250 mm' },
		  { value: '2251-2500', key: '2251-2500', label: '2251–2500 mm' },
		  { value: '2501-2750', key: '2501-2750', label: '2501–2750 mm' },
		  { value: '2751-3000', key: '2751-3000', label: '2751–3000 mm' },
		  { value: '3001-3500', key: '3001-3500', label: '3001–3500 mm' },
		  { value: '3501-4000', key: '3501-4000', label: '3501–4000 mm' },
		  { value: '4001-6000', key: '4001-6000', label: '4001–6000 mm' },
		  { value: '6001-10000', key: '6001-10000', label: '6001+ mm' }
		];

		generateDropdown({ containerId: 'load_length-select', options, multiselect: false, name: 'load_length' });
	} loadLengthSelectDropdown();

	var sortDropdownOptions = [
		{ value: 'offers', key: 'offers', label: 'Promoted' },
		{ value: 'price_asc', key: 'price_asc', label: 'Price Low - High' },
		{ value: 'price_desc', key: 'price_desc', label: 'Price High - Low' }
	];

	function sortDropdown() {
		
	    generateDropdown({
	        containerId: 'sort-select',
	        options: sortDropdownOptions,
	        multiselect: false,
	        name: 'order'
	    });
	}
	sortDropdown();

function getSelectedFromURLCompat(name, multiselect = false, search = window.location.search) {
	  const raw = (search || '').startsWith('?') ? search.slice(1) : (search || '');
	  const params = new URLSearchParams(raw);
	  const values = [];

	  const single = params.get(name);
	  if (!multiselect && single != null && single !== '') {
	    values.push(single);
	  }

	  params.getAll(`${name}[]`).forEach(v => {
	    if (v != null && v !== '') values.push(v);
	  });

	  for (const [k, v] of params.entries()) {
	    if (k.startsWith(name + '[') && k.endsWith(']') && v != null && v !== '') {
	      values.push(v);
	    }
	  }

	  return Array.from(new Set(values.map(String)));
	}


function generateDropdown({
	containerId,
	options,
	multiselect = false,
	name,
	preselectedValues = [],
	useUrlSelection = true,
	disallowEmpty = false,
	modelContainerId = null,
	modelName = 'model',
	formId = null
}) {
	const context = getDropdownContext({ containerId, formId });
	const { container, form } = context;
	if (!container) return;

	const listbox = container.querySelector('.multiselect-list');
	const listboxdiv = container.querySelector('.multiselect-list-div');
	const downArrow = container.querySelector('[alt="Down Arrow"]');

	if (downArrow && options.length < 7) {
		downArrow.classList.add('hidden');
	}

	if (!listbox || !listboxdiv) return;

	listbox.innerHTML = '';
	const selectedValues = new Set();

	const fromURL = useUrlSelection ? getSelectedFromURLCompat(name, multiselect) : [];
	const mergedPreselected = new Set([
		...fromURL.map(String),
		...preselectedValues.map(String)
	]);

	options.forEach(({ value, label }) => {
		const li = document.createElement('li');
		li.className = 'relative cursor-pointer py-2 pr-9 pl-3 text-gray-900 select-none hover:bg-[#eee] border border-[#ffffff] border-[1px] hover:border-[#005bdd]';
		li.setAttribute('role', 'option');
		li.setAttribute('data-value', value);

		const isPreSelected = mergedPreselected.has(String(value));

		li.innerHTML = `
			<div class="flex items-center">
				<span class="block truncate">${label}</span>
			</div>
			<span class="absolute inset-y-0 right-0 flex items-center pr-4">
				<img src="/themes/driveelectric/img/icons/${isPreSelected ? 'dropdowntick' : 'dropdowntickempty'}.svg" class="tick w-[20px] h-[20px]" alt="Tick" />
			</span>
			<input type="hidden" name="${name}${multiselect ? '[]' : ''}" value="${value}" data-name="${label}" ${isPreSelected ? '' : 'disabled'} />
		`;

		if (isPreSelected) {
			selectedValues.add(label);
			addToGlobalSelection(name, value, label);
			li.classList.add('font-semibold');
		}

		const input = li.querySelector('input[type="hidden"]');
		const tick = li.querySelector('.tick');

		li.addEventListener('click', () => {
			if (multiselect) {
				const isSelected = !input.disabled;

				input.disabled = isSelected;

				tick.src = isSelected
					? '/themes/driveelectric/img/icons/dropdowntickempty.svg'
					: '/themes/driveelectric/img/icons/dropdowntick.svg';

				li.classList.toggle('font-semibold', !isSelected);

				if (isSelected) {
					selectedValues.delete(label);
					removeFromGlobalSelection(name, value, input);
				} else {
					selectedValues.add(label);
					addToGlobalSelection(name, value, label);
				}
			} else {
				const wasSelected = !input.disabled;

				if (wasSelected) {
					if (disallowEmpty) return;

					input.disabled = true;
					tick.src = '/themes/driveelectric/img/icons/dropdowntickempty.svg';
					li.classList.remove('font-semibold');

					container.querySelectorAll('input[type="hidden"]:not([disabled])').forEach(i => {
						i.disabled = true;
						removeFromGlobalSelection(name, i.value, i);
					});

					container.querySelectorAll('.tick').forEach(t => {
						t.src = '/themes/driveelectric/img/icons/dropdowntickempty.svg';
					});

					container.querySelectorAll('li').forEach(el => {
						el.classList.remove('font-semibold');
					});

					updateDisplay(container, label);
					if (typeof jsLoadResults !== 'undefined' && jsLoadResults === true) {
						loadSearchResults();
					}

					return;
				}

				container.querySelectorAll('input[type="hidden"]:not([disabled])').forEach(i => {
					i.disabled = true;
					removeFromGlobalSelection(name, i.value, i);
				});

				container.querySelectorAll('.tick').forEach(t => {
					t.src = '/themes/driveelectric/img/icons/dropdowntickempty.svg';
				});

				container.querySelectorAll('li').forEach(li => {
					li.classList.remove('font-semibold');
				});

				input.disabled = false;
				tick.src = '/themes/driveelectric/img/icons/dropdowntick.svg';
				li.classList.add('font-semibold');

				selectedValues.clear();
				selectedValues.add(label);
				addToGlobalSelection(name, value, label);
			}

			updateDisplay(container);

			if (['budget-from', 'budget-to'].includes(name)) {
				budgetNameValue({ form });
			}

			if (name === 'budget-from') {
				container.classList.remove('open');
			}

			if (name === 'budget-to') {
				container.classList.remove('open');
			}

			if (name === 'make' && modelContainerId) {
				const selectedMakes = [
					...container.querySelectorAll(`input[name="make[]"]:not([disabled])`)
				].map(i => i.value);

				const targetModelContainerId = modelContainerId;

				if (selectedMakes.length > 0) {
					resetLinkedModelDropdown(targetModelContainerId, 'Model');

					const searchTypeValue = queryWithinContext(context, '#search-type', true)?.value || 'car';

					loadModelsSelect(searchTypeValue, selectedMakes, false, {
						containerId: targetModelContainerId,
						formId: context.formId,
						name: modelName
					});
				} else {
					resetLinkedModelDropdown(targetModelContainerId, 'Model');
				}
			}

			if (name === 'colour') {
				const selectedInput = li.querySelector('input[type="hidden"]:not([disabled])');
				const selectedValue = selectedInput ? selectedInput.value : null;

				if (!selectedValue) return;

				const matchingSwatch = (form || document).querySelector(
					`.derivative-colour-picker .colour-picker span[data-paint-id="${selectedValue}"]`
				);

				if (matchingSwatch) {
					matchingSwatch.click();
				}
			}

			if (['contract-length-select', 'yearly-mileage-select'].includes(containerId)) {
				const activeInput = li.querySelector('input[type="hidden"]:not([disabled])');
				const selectedValue = activeInput ? activeInput.value : null;

				if (selectedValue) {
					const fieldMap = {
						'contract-length-select': ['term'],
						'yearly-mileage-select': ['mileage']
					};

					const fieldNames = fieldMap[containerId] || [];

					fieldNames.forEach(fieldName => {
						const fieldInput = form?.querySelector(`[name="${fieldName}"]`) || document.querySelector(`[name="${fieldName}"]`);
						if (fieldInput) fieldInput.value = selectedValue;
					});

					loadPrice();
					colourDropdownInit();
				}
			}

			if (form?.querySelector('.counter') || document.querySelector('.counter')) {
				if (form) {
					const formParams = new URLSearchParams(new FormData(form)).toString();
					vehicleCount(formParams);
				}
			}

			if (['colour-select', 'interior-select'].includes(containerId)) {
				populateQueryFormForColourAndInterior(form);
			}

			if (typeof jsLoadResults !== 'undefined' && jsLoadResults === true) {
				loadSearchResults();
			}
		});

		listbox.appendChild(li);
	});

	const containerClick = (e) => {
		e.stopPropagation();

		if (listboxdiv?.innerHTML !== '') {
			if (!listboxdiv.contains(e.target)) {
				closeAllDropdowns(container);

				if (container.classList.contains('open')) {
					container.classList.remove('open');
				} else {
					container.classList.add('open');
				}
			}
		}
	};

	if (container._dropdownClick) {
		container.removeEventListener('click', container._dropdownClick);
	}

	container._dropdownClick = containerClick;
	container.addEventListener('click', containerClick);

	updateDisplay(container);
	showSelectedValues(container);
	loadFilterOptionRow();
}
//FOR GENERATED DROPDOWNS - IF USER CLICKS AWAY THEN CLOSE IT
document.addEventListener('click', (event) => {
	const isClickInsideAny = [...document.querySelectorAll('.multiselect-container')]
		.some(container => container.contains(event.target));

	if (!isClickInsideAny) {
		closeAllDropdowns();
	}
});

function closeAllDropdowns(exceptContainer = null) {
	const allDropdowns = document.querySelectorAll('.multiselect-list-div');
	allDropdowns.forEach(dropdown => {
		const container = dropdown.closest('.multiselect-container') || dropdown.parentElement;

		// Skip if container is inside #budgetDropDownBase
		if (document.getElementById('budgetDropDownBase')?.contains(container)) {
			if (container !== exceptContainer) return; // Only skip closing others inside #budgetDropDownBase
		}

		if (container !== exceptContainer) {
			dropdown.classList.add('hidden');
			container.classList.remove('open');
		}
	});
}

function budgetNameValue(context = {}) {
	const form = context.form || null;
	const scope = form || document;
	const fromInput = scope.querySelector('[id^="budget-from"] input[type="hidden"]:not([disabled])');
	const toInput = scope.querySelector('[id^="budget-to"] input[type="hidden"]:not([disabled])');

	if ((!fromInput || fromInput.disabled) && (!toInput || toInput.disabled)) {
		return;
	}

	const maxTo = Math.max(...budgetOptionsArray.map(o => Number(o.value)));
	let from = fromInput && fromInput.value !== '' ? Number(fromInput.value) : 0;
	let to   = toInput && toInput.value !== '' ? Number(toInput.value) : maxTo;

	// A lone budget dropdown represents the maximum monthly price.
	if (fromInput && !toInput) {
		to = from;
		from = 0;
	}

	// Ensure logical range
	if (from > to) to = from;
	
	const hiddenBudgetInput = form?.querySelector('input[name="budget"]') || document.querySelector('input[name="budget"]');
	if (hiddenBudgetInput) hiddenBudgetInput.value = `${from}-${to}`;
}

function populateQueryFormForColourAndInterior(targetForm = null) {
	const form = targetForm || document.getElementById('quote-form');
	if (!form) return;

	const quoteType = form.querySelector('[name="type"]')?.value || 'business';
	const priceKey = quoteType == 'personal' ? 'monthlyVat' : 'monthly';

	let optionDescriptions = [];
	let total = 0;

	// Handle Paint
	let paintDesc = '';
	const selectedPaint = paints.find(paint =>
		(form.querySelector(`#colour-select input[type="hidden"][value="${paint.id}"]:not([disabled])`) ||
			document.querySelector(`#colour-select input[type="hidden"][value="${paint.id}"]:not([disabled])`))
	);
	
	if (selectedPaint) {
		const paintPrice = parseFloat(selectedPaint[priceKey] || 0);
		total += paintPrice;
		paintDesc = `Colour: ${selectedPaint.name}${paintPrice > 0 ? ` (£${paintPrice.toFixed(2)})` : ''}`;
		optionDescriptions.push(paintDesc);
	}

	// Handle Trim
	let trimDesc = '';
	const selectedTrim = trims.find(trim =>
		(form.querySelector(`#interior-select input[type="hidden"][value="${trim.uri}"]:not([disabled])`) ||
			document.querySelector(`#interior-select input[type="hidden"][value="${trim.uri}"]:not([disabled])`))
	);

	if (selectedTrim) {
		const trimPrice = parseFloat(selectedTrim[priceKey] || 0);
		total += trimPrice;
		trimDesc = `Interior: ${selectedTrim.name}${trimPrice > 0 ? ` (£${trimPrice.toFixed(2)})` : ''}`;
		optionDescriptions.push(trimDesc);
	}


	// Update Form Inputs
	let optionsInput = form.querySelector('input[name="options"]');
	if (!optionsInput) {
		optionsInput = document.createElement('input');
		optionsInput.type = 'hidden';
		optionsInput.name = 'options';
		form.appendChild(optionsInput);
	}
	optionsInput.value = optionDescriptions.join(' - ');

	let totalInput = form.querySelector('input[name="options_total"]');
	if (!totalInput) {
		totalInput = document.createElement('input');
		totalInput.type = 'hidden';
		totalInput.name = 'options_total';
		form.appendChild(totalInput);
	}
	totalInput.value = total.toFixed(2);
}


function addToGlobalSelection(name, value, label) {
	const exists = selectedOptionsForFilterRow.some(item => item.value === value && item.name === name);
	if (!exists) {
		selectedOptionsForFilterRow.push({ name, value, label });
		loadFilterOptionRow();
	}
}

function removeFromGlobalSelection(name, value, sourceInput = null) {
	const hasMatchingSelection = getEnabledInputsForName(name, sourceInput)
		.some(input => String(input.value) === String(value));

	if (!hasMatchingSelection) {
		selectedOptionsForFilterRow = selectedOptionsForFilterRow.filter(item => !(item.name === name && item.value === value));
		loadFilterOptionRow();
	}
}


if (document.getElementById('budgetDropDownBase')) {
  document.getElementById('budgetDropDownBase').addEventListener('click', function (e) {
    e.stopPropagation(); // Prevent triggering the document-level click listener

    const container = this;
    const dropdown = container.querySelector('.multiselect-list-div');

    // Close all other dropdowns except this one
    closeAllDropdowns(container);

    if (dropdown) {
      if(container.classList.contains('open')){
      	container.classList.remove('open');
      } else {
      	container.classList.add('open');
      }
    }
  });
}

function loadFilterOptionRow() {
	const container = document.getElementById('selected_filter_bubbles');
	if (!container) return;

	container.innerHTML = '';

	selectedOptionsForFilterRow.forEach(({ name, value, label }) => {
		const bubble = document.createElement('div');
		bubble.className = 'inline-flex items-center bg-[#140A5B] text-white rounded-[4px] px-3 py-1 whitespace-nowrap';
		bubble.setAttribute('data-key', value);

		bubble.innerHTML = `
			<span class="text-[16px] leading-[24px] font-normal">${label}</span>
			<img src="/themes/driveelectric/img/icons/close-white.svg" alt="Close" 
				class="w-[10px] h-[10px] cursor-pointer ml-[10px] mr-[10px]" 
				data-key="${value}" 
				data-name="${name}" />
		`;

		const closeBtn = bubble.querySelector('img');

		closeBtn.addEventListener('click', () => {
			const paramKey = name.endsWith('[]') ? name : (name + '[]'); // support for multiselect
			const currentUrl = new URL(window.location.href);
			const params = currentUrl.searchParams;

			if (params.has(name)) {
				const all = params.getAll(name).filter(v => v !== value);
				params.delete(name);
				all.forEach(v => params.append(name, v));
			} else if (params.has(paramKey)) {
				const all = params.getAll(paramKey).filter(v => v !== value);
				params.delete(paramKey);
				all.forEach(v => params.append(paramKey, v));
			}

			window.location.href = `${currentUrl.pathname}?${params.toString()}`;
		});

		container.appendChild(bubble);
	});
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeAllDropdowns();
  }
});

const clear_all_mobile = document.getElementById('clear_all_mobile');
if (clear_all_mobile) {
    clear_all_mobile.addEventListener('click', function(e) {
        e.preventDefault();

        const dropdownIds = [
            'manufacturer-multiselect',
            'model-select',
            'bodyType-select',
            'bodyType-van-select',
            'budget-from',
            'budget-to',
            'newUsed-select',
            'payload-select',
            'load_length-select',
            'transmission-select',
            'fueltype-select',
            'mpgRange-select',
            'mileage-select',
            'intialPayment-select'
        ];

        dropdownIds.forEach(id => {
            const container = document.getElementById(id);
            if (container) {
                const label = container.getAttribute('data-default-label') || 'Select';
                // clearBtn(container, label);
            }
        });

        loadFilterOptionRow();
        // console.log('All dropdowns cleared');

    });
}



